import { getOffers, getInquiry } from 'lib/services/inquiry'
import { sendOfferRequest } from 'lib/services/offer-requests/send-offer'
import { subscribeNewsletter } from '../newsletter'

/**
 * Get common data fields from formData.
 */
const parseCommonData = (formData) => ({
  name: formData.name.value,
  email: formData.email.value,
  phone: formData.phone.value,
  company: formData.company.value,
  login_email: formData.login_email.value,
})

/**
 * Transform offers & form data to full request objects
 */
const parseRequestData = (offerData, commonData) => {
  const inquiries = offerData.map((offer) => getInquiry(offer.id))
  return inquiries.map((inquiry) => ({
    ...inquiry,
    ...commonData,
  }))
}

/**
 * Parse data for offer requests.
 * Send each request separately.
 */
export const sendOfferRequests = async (formData, offerId) => {
  const commonData = parseCommonData(formData)
  const offerData = getOffers(offerId)

  let subscriptionResult
  if (formData.newsletter.value === true) {
    subscriptionResult = subscribeNewsletter({
      email: formData.email.value,
      name: formData.name.value,
      phone: formData.phone.value,
    })
  }

  const offerRequests = parseRequestData(offerData, commonData)

  const requests = offerRequests.map((request) => sendOfferRequest(request))

  const result = await Promise.all(requests, subscriptionResult)

  return result
}

export default {
  sendOfferRequests,
}
